import { HugeiconsIcon } from "@hugeicons/react";
import { Copy01Icon, Tick01FreeIcons } from "@hugeicons/core-free-icons";
import { useState } from "react";

export const useCopy = (props) => {
  const { value } = props;
  const [copyState, setCopyState] = useState("idle"); // "idle", "copying", "copied", "error"

  const handleCopy = async () => {
    setCopyState("copying");

    try {
      await navigator.clipboard.writeText(value);
      setCopyState("copied");

      // Reset to idle state after 2 seconds
      setTimeout(() => {
        setCopyState("idle");
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      try {
        const textArea = document?.createElement("textarea");
        if (!textArea) return;
        textArea.value = value;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopyState("copied");

        // Reset to idle state after 2 seconds
        setTimeout(() => {
          setCopyState("idle");
        }, 2000);
      } catch (fallbackErr) {
        setCopyState("error");

        // Reset to idle state after 3 seconds
        setTimeout(() => {
          setCopyState("idle");
        }, 3000);
      }
    }
  };

  const ButtonIcon = ({ iconSize = 18 }) => {
    switch (copyState) {
      case "copied":
        return (
          <>
            <HugeiconsIcon size={iconSize ?? 18} icon={Tick01FreeIcons} />
          </>
        );
      default:
        return (
          <>
            <HugeiconsIcon size={iconSize ?? 18} icon={Copy01Icon} />
          </>
        );
    }
  };

  return {
    handleCopy,
    ButtonIcon,
    copyState,
  };
};
